import { firstValueFrom } from 'rxjs';

import { MpsUser } from '../../app/models/mps-user.model';
import { MpsPermissionHelper } from '../helpers/mps-permission.helper';
import { mpsRouteNames } from '../mps-route-names';
import { MpsUserService } from '../services/mps-user.service';

/** Clé de traduction affichée sur la page de login (canal `?error=`, cf. MpsLoginComponent). */
const NO_ACCESS_REASON = 'messages.api_response.auth.error.access_denied';

export function mpsFetchUser(userService: MpsUserService) {
  return async (): Promise<MpsUser | undefined> => {
    try {
      if (!window.location.href.includes('oauth2/token') && !window.location.href.includes('login?error=')) {
        const user = await firstValueFrom(userService.fetchUser());

        if (!MpsPermissionHelper.hasApplicationAccess(new MpsUser(user))) {
          await endSessionWithoutAccess(userService);
          return undefined;
        }

        return user;
      }

      return undefined;
    } catch (_error) {
      return undefined;
    }
  };
}

/**
 * Déconnecte un compte sans rôle métier (ex : USER) puis renvoie au login avec un message.
 * Rechargement complet, pour que l'application ne continue pas à router avec un utilisateur refusé.
 * La page de login ne relance pas l'authentification : pas de boucle.
 */
async function endSessionWithoutAccess(userService: MpsUserService): Promise<void> {
  await firstValueFrom(userService.logout()).catch(() => userService.clearLocalSession());
  window.location.href = `/${mpsRouteNames.auth}/${mpsRouteNames.login}?error=${NO_ACCESS_REASON}`;
}
